import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconMarkerCircle: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconMarkerCircle"><Path fillRule="evenodd" clipRule="evenodd" d="M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM6.28748 18.2943C7.37916 16.7666 7.96577 15.6344 8.37119 14H15.6288C16.0342 15.6344 16.6208 16.7666 17.7125 18.2943C16.2033 19.6648 14.1992 20.5 12 20.5C9.80079 20.5 7.79667 19.6648 6.28748 18.2943ZM9 12.5V9.5L15 8V12.5H9Z" fill="currentColor"/></CentralIconBase>;
});

export default IconMarkerCircle;
